import React, { useState } from 'react';
import styled from 'styled-components';
import Loader from '../Components/Loader'; 
import SuccessCard from '../Components/SuccessCard'; 
import ErrorCard from '../Components/ErrorCard'; 
import useAddimtContract from '../Hooks/IMTcontractHooks/useAddimtContract';
import MunicipalitySelector from '../Components/Municipality';
import ProvinceSelector from '../Components/ProvinceSelector';

const ImtContractAdd = ({darkMode}) => {
 
  const { loading, success, error, addimtContract } = useAddimtContract();
      const [showSuccess, setShowSuccess] = useState(false);
      const [showError, setShowError] = useState(false);

  const [formData, setFormData] = useState({
    nameofsystem: '',
    typeofsystem: '',
    nameofia: '',
    province: '',
    municipality: '',
    barangay: '',
    lastname: '',
    firstname: '',
    middlename: '',
    extensionname: '',
    sex: '',
    birthday: '',
    mothersmaidenname: '',
    provincer: '',
  });

  const [isExpanded] = useState(true);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await addimtContract(formData); 
  };
    

  return (
    <Container darkMode={darkMode}  isExpanded={isExpanded}>
      <FormContainer  darkMode={darkMode} isExpanded={isExpanded}>
      <Title darkMode={darkMode}><span>RSBA MASTERLIST FORM</span></Title>
      {loading && <LoaderOverlay><Loader /></LoaderOverlay>}
      {showSuccess && <SuccessCard onClose={() => setShowSuccess(false)} />}
      {showError && <ErrorCard errorMessage={error} onClose={() => setShowError(false)} />}
        <form onSubmit={handleSubmit}>
        <GridContainer darkMode={darkMode}>
  {Object.keys(formData).map((key) => (
    <FieldGroup key={key} darkMode={darkMode}>
      <label htmlFor={key}>
        {key.replace(/_/g, ' ').toUpperCase()}
      </label>
      {key === 'municipality' ? (
  <MunicipalitySelector formData={formData} setFormData={setFormData} darkMode={darkMode} />
) : key === 'province' ? (
  <ProvinceSelector formData={formData} setFormData={setFormData} darkMode={darkMode} />
) : (
  <input
    type="text"
    className="form-control"
    id={key}
    name={key}
    value={formData[key]}
    onChange={handleChange}
  />
)}

    </FieldGroup>
  ))}
</GridContainer>
          <FormButtonContainer>
            <SubmitButton type="submit">Add</SubmitButton>
          </FormButtonContainer>
        </form>
      </FormContainer>
    </Container>
  );
};

export default ImtContractAdd;

const Container = styled.div`
padding: ${(props) => (props.isExpanded ? '1px' : '10px')};
width: 100%;
min-height: 100vh;
height: auto;
background-size: 100%;
background-position: center;
display: flex;
flex-direction: row;
justify-content: flex-start;
overflow-y: auto;
position: relative;
transition: transform 0.3s ease; 
transform: ${(props) => (props.isExpanded ? 'translateX(0%)' : 'translateX(80%)')};
margin-top: 10px;
`;


const FormContainer = styled.div`
width: ${(props) => (props.isExpanded ? '75%' : '100%')};
margin-top: 0px;
padding-bottom: 10px;
flex-grow: 1;
transition: width 0.3s ease;

`;

const Title = styled.h2`
  position: sticky;
  top: 0;
  z-index: 100;
  padding: 10px 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: ${({ darkMode }) => (darkMode ? 'blur(10px)' : 'none')};
  -webkit-backdrop-filter: ${({ darkMode }) => (darkMode ? 'blur(10px)' : 'none')};
  background: ${({ darkMode }) =>
    darkMode
      ? 'rgba(3, 82, 33, 0.45)'
      : 'rgba(255, 255, 255, 0.65)'};

  box-shadow: ${({ darkMode }) =>
    darkMode
      ? '0 4px 30px rgba(0, 0, 0, 0.1)'
      : '0 4px 30px rgba(0, 0, 0, 0.05)'};

  span {
    background-color: ${({ darkMode }) => (darkMode ? 'rgba(255, 255, 255, 0.6)' : '#18591d')};
    color: ${({ darkMode }) => (darkMode ? '#1a1a1a' : '#fff')};
    padding: 6px 24px;
    font-size: 1rem;
    font-weight: bold;
    border-radius: 8px;
    position: relative;
    z-index: 1;
  }

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 2px;
    width: 30px;
    background-color: ${({ darkMode }) => (darkMode ? '#eee' : '#333')};
    margin: 0 8px;
    margin-top: 35px;
  }
`;


  const LoaderOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999; // on top of everything
  `;

  const GridContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    padding: 15px;
    background-color: ${({ darkMode }) => (darkMode ? 'rgb(36, 110, 45)' : '#f9f9f9')};
    border: 1px solid #f2f2f2;

    @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
  `;

  const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;

  label {
    font-weight: bold;
    font-size: .75rem;
    margin-bottom: 5px;
    color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#333')};
  }

  input {
    padding: 3px;
    font-size: 1rem;
    border-radius: 6px;
    border: 1px solid ;
    color: ${({ darkMode }) => (darkMode ? '#333' : '#333')};
    background-color: ${({ darkMode }) => (darkMode ? '#dcdcdc' : '#f2f2f2')};
    width: 100%;
  }
`;


const FormButtonContainer = styled.div`
text-align: center;
margin-top: 0px;
`

const SubmitButton = styled.button`
background-color: #18591d;
color: white;  font-weight: bold;
padding: 10px 100px;
border: none;
border-radius: 5px;
cursor: pointer;
transition: background-color 0.3s ease;

&:hover {
  background-color: #218838;
}
`;

